/* 
    Date Formatting Annotations: 
        YYYY - Full Year (Numeric)
        YY - Last two digits
        MM - Month (Numeric)
        MMM - Month with short Name
        MMMM - Month with Full Name
        DD - Date (Numeric)
        d - Day with short Name
        dd - Day with full Name
        hh  - Hours
        mm  - Minutes    
        ss  - seconds
*/

const dateFormatter = (date:any, format:String) => {
    const d:Date = new Date(date)
    const reqformat = format.trim().split(/[^A-Za-z]/)
    // const result = {}
    let resultDate = format
    const methods:any = {
      'YYYY': (d:Date) => getFullYear(d),
      'YY': (d:Date) => getShortYear(d),
      'MM' : (d:Date) => getMonth(d),
      'MMM' : (d:Date) => getMonthShort(d),
      'MMMM': (d:Date) => getMonthLong(d),
      'DD' : (d:Date) => getDate(d),
      'd' : (d:Date) => getDay(d),
      'dd': (d:Date) => getDayLong(d),
      'hh': (d:Date) => getHour(d),
      'mm': (d:Date) => getMinutes(d),
      'ss': (d:Date) => getSeconds(d)
    }
    reqformat?.map((fmt:string) => {
      if(fmt){
        resultDate = resultDate.replace(fmt,  methods[fmt]?.(d))
      }
    })
    // const res = resultDate.replace('YYYY', '')
    return resultDate
  }
export default dateFormatter



  const getShortYear = (d:Date) => {
    return ('' + d.getFullYear()).substring(2);
  }
  
  const getFullYear = (d:Date) => {
    return d.getFullYear()
  }
  const getMonth = (d:Date) => {
    return ("0" + (d.getMonth() +1)).slice(-2);
  }
  const getMonthShort = (d:Date) => {
    return monthShort[d.getMonth()]
  }
  const getMonthLong = (d:Date) => {
    return monthLong[d.getMonth()]
  }
  const getDate = (d:Date) => {
    return ("0" + (d.getDate())).slice(-2);
  }
  const getDay = (d:Date) => {
    return dayShort[d.getDay()]
  }
  const getDayLong = (d:Date) => {
    return dayLong[d.getDay()]
  }
  const getHour = (d:Date) => {
    return  ("0" + d.getHours()).slice(-2);
  }
  const getMinutes = (d:Date) => {
    return  ("0" + d.getMinutes()).slice(-2);
  }
  const getSeconds = (d:Date) => {
    return  ("0" + d.getSeconds()).slice(-2);
  }



  const dayShort:any = {
    0: "Sun",
    1: "Mon",
    2: "Tue",
    3: "Wed",
    4: "Thu",
    5: "Fri",
    6: "Sat",
  };
  const monthShort:any = {
    0: "Jan",
    1: "Feb",
    2: "Mar",
    3: "Apr",
    4: "May",
    5: "Jun",
    6: "Jul",
    7: "Aug",
    8: "Sep",
    9: "Oct",
    10: "Nov",
    11: "Dec",
  }
  
  const dayLong:any = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };
  const monthLong:any = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
  }